import FormTitle from '@core/components/FormTitle';
import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tooltip,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { MdHighlightOff } from 'react-icons/md';
import faturamentoApi from '../../../../../services/api/faturamentoApi';
import VendaPagamentoAVista from './VendaPagamentoAVista';
import VendaPagamentoParcelado from './VendaPagamentoParcelado';
import { vendaFormaPagamentoStyles } from './styles';

const VendaFormaPagamento = ({
  id,
  name,
  values,
  onChange,
  onBlur,
  errors,
  touched,
  onGerarParcelas,
  onChangeConta,
  onChangeDataPrimeiraParcela,
  onChangeCondicaoPagamento,
  submitCount,
  disabled,
}) => {
  const styles = vendaFormaPagamentoStyles();
  const [faturamentoAutomatico, setFaturamentoAutomatico] = useState(false);
  const [openTooltipEnvioAutomatico, setOpenTooltipEnvioAutomatico] = useState(false);
  const [openTooltipEnvioNF, setOpenTooltipEnvioNF] = useState(false);

  useEffect(() => {
    const isAutomatico = async () => {
      const automatico = await faturamentoApi.faturamentoAutomaticoVenda();
      setFaturamentoAutomatico(automatico.data);
    };
    isAutomatico();
  }, []);

  const handleCloseAutomatico = () => {
    setOpenTooltipEnvioAutomatico(false);
  };

  const handleOpenAutomatico = () => {
    setOpenTooltipEnvioAutomatico(true);
  };

  const handleCloseNF = () => {
    setOpenTooltipEnvioNF(false);
  };

  const handleOpenNF = () => {
    setOpenTooltipEnvioNF(true);
  };

  const addEmail = () => {
    const { emailsCliente } = values;
    emailsCliente.push({ email: '', principal: false });

    onChange({ target: { id: `emailsCliente${emailsCliente.length}`, values: '' } });
  };

  const removeEmail = (index) => {
    const { emailsCliente } = values;
    emailsCliente.splice(index, 1);
    onChange({ target: { id: `emailsCliente${index}`, values: undefined } });
  };

  return (
    <>
      <FormTitle title="Informações do pagamento" />
      <Grid container spacing={3} className="mb-16">
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <SelectInput
              id={`${name}.formaRecebimento`}
              name={`${id}.formaRecebimento`}
              label="Forma de recebimento"
              value={values?.pagamento?.formaRecebimento}
              onChange={onChange}
              onBlur={onBlur}
              required
              error={errors?.pagamento?.formaRecebimento}
              helperText={errors?.pagamento?.formaRecebimento}
              touched={!!errors?.pagamento?.formaRecebimento}
              options={
                values?.cliente?.tipoPessoa !== 'ESTRANGEIRA'
                  ? [
                      { id: 'BOLETO', title: 'Boleto' },
                      { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
                      { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
                      { id: 'CHEQUE', title: 'Cheque' },
                      { id: 'DINHEIRO', title: 'Dinheiro' },
                      { id: 'TED_DOC', title: 'TED/DOC' },
                      { id: 'PIX', title: 'PIX' },
                    ]
                  : [
                      { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
                      { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
                      { id: 'CHEQUE', title: 'Cheque' },
                      { id: 'DINHEIRO', title: 'Dinheiro' },
                      { id: 'TED_DOC', title: 'TED/DOC' },
                      { id: 'PIX', title: 'PIX' },
                    ]
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <FormControl disabled={disabled} variant="outlined" style={{ width: '100%' }} error={!!errors?.tipoPagamento}>
            <InputLabel id="condicao-pagamento">Condição de pagamento *</InputLabel>
            <Select
              id={`${id}.tipoPagamento`}
              name={`${id}.tipoPagamento`}
              value={values?.pagamento?.tipoPagamento}
              onChange={onChangeCondicaoPagamento}
              onBlur={onBlur}
              labelId="condicao-pagamento"
              label="Condição de pagamento *"
              disabled={values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada}
            >
              <MenuItem value="A_VISTA">À vista</MenuItem>
              <MenuItem value="PARCELADO">Parcelado</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {values?.pagamento?.tipoPagamento === 'A_VISTA' && (
          <VendaPagamentoAVista
            id={`${id}.avista`}
            name={`${name}.avista`}
            onChange={onChange}
            onBlur={onBlur}
            values={values?.pagamento?.avista}
            errors={errors?.pagamento?.avista}
            touched={touched?.pagamento?.avista}
            onChangeConta={onChangeConta}
            submitCount={submitCount}
          />
        )}
        {values?.pagamento?.tipoPagamento === 'PARCELADO' && (
          <VendaPagamentoParcelado
            id={`${id}.parcelamento`}
            name={`${name}.parcelamento`}
            onChange={onChange}
            onBlur={onBlur}
            values={values?.pagamento?.parcelamento}
            errors={errors?.pagamento?.parcelamento}
            touched={touched?.pagamento?.parcelamento}
            onGerarParcelas={onGerarParcelas}
            onChangeDataPrimeiraParcela={onChangeDataPrimeiraParcela}
            submitCount={submitCount}
            disabled={disabled}
            possuiNotaFiscalTransmitida={values?.possuiNotaFiscalTransmitida}
            possuiCobrancaRegistrada={values?.possuiCobrancaRegistrada}
          />
        )}
      </Grid>
      <Grid container spacing={3} className="mt-16 mb-16">
        <Grid item xs={12}>
          <Tooltip
            open={!values?.envioAutomaticoCobranca && openTooltipEnvioAutomatico}
            onClose={handleCloseAutomatico}
            onOpen={handleOpenAutomatico}
            title="Com este recurso você poderá automatizar o envio da cobrança e nota fiscal para seu cliente"
            placement="top"
          >
            <FormControlLabel
              label="Envio automático"
              control={
                <Switch
                  id="envioAutomaticoCobranca"
                  name="envioAutomaticoCobranca"
                  value={values?.envioAutomaticoCobranca}
                  checked={values?.envioAutomaticoCobranca}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="small"
                  color="primary"
                  disabled={values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada}
                />
              }
            />
          </Tooltip>
        </Grid>
        {values?.envioAutomaticoCobranca && (
          <Grid item xs={12}>
            <div id="hintEnvioNF">
              <p>O envio da Nota Fiscal seguirá a opção de faturamento automático marcada nos parâmetros de receita.</p>
              <p>
                O envio da cobrança acontecerá imediatamente quando venda for a vista e 10 dias antes do vencimento
                quando parcelada.
              </p>
            </div>
          </Grid>
        )}
      </Grid>

      {/* RNE-504 */}
      {values?.envioAutomaticoCobranca && (
        <>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    id="enviarCobrancaEmail"
                    name="enviarCobrancaEmail"
                    value={values?.enviarCobrancaEmail}
                    checked={values?.enviarCobrancaEmail}
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada}
                  />
                }
                label="Enviar cobrança por e-mail"
              />
            </Grid>
            <Grid item xs={9}>
              <Tooltip
                open={!faturamentoAutomatico && openTooltipEnvioNF}
                onClose={handleCloseNF}
                onOpen={handleOpenNF}
                title="O envio automático da Nota Fiscal só é possível quando o faturamento é automático."
                placement="top"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      id="enviarNotaFiscalEmail"
                      name="enviarNotaFiscalEmail"
                      value={values?.enviarNotaFiscalEmail}
                      checked={values?.enviarNotaFiscalEmail}
                      onChange={onChange}
                      onBlur={onBlur}
                      size="small"
                      disabled={
                        !faturamentoAutomatico ||
                        values?.possuiNotaFiscalTransmitida ||
                        values?.possuiCobrancaRegistrada
                      }
                    />
                  }
                  label="Enviar Nota Fiscal por e-mail"
                />
              </Tooltip>
            </Grid>
            <Grid item xs={5}>
              <TextInput
                fullWidth
                id="emailsCliente[0].email"
                label="E-mail principal do cliente"
                type="email"
                variant="outlined"
                value={values?.emailsCliente[0]?.email}
                onChange={onChange}
                onBlur={onBlur}
                maxLength={100}
                error={errors?.emailsCliente && errors?.emailsCliente[0]?.email}
                helperText={errors?.emailsCliente && errors?.emailsCliente[0]?.email}
                touched={!!errors?.emailsCliente && errors?.emailsCliente[0]?.email}
                required
                disabled={values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada}
              />
            </Grid>
          </Grid>

          {values?.emailsCliente?.length > 1 &&
            values.emailsCliente.map((emailCliente, index) => {
              return (
                index > 0 && (
                  <Grid container spacing={3} className={index === 2 ? 'mb-16' : ''}>
                    <Grid item xs={5}>
                      <TextInput
                        fullWidth
                        id={`emailsCliente[${index}].email`}
                        label="E-mail adicional"
                        type="email"
                        variant="outlined"
                        value={emailCliente.email}
                        onChange={onChange}
                        onBlur={onBlur}
                        maxLength={100}
                        disabled={values?.possuiNotaFiscalTransmitida || values?.possuiCobrancaRegistrada}
                        // error={errors?.emailsCliente[index]}
                        // helperText={errors?.emailsCliente[index]}
                        // touched={!!errors?.emailsCliente[index]}
                      />
                    </Grid>
                    <Tooltip title="Remover e-mail" placement="right-end">
                      <IconButton onClick={() => removeEmail(index)}>
                        <MdHighlightOff size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )
              );
            })}

          {values?.emailsCliente?.length < 3 &&
            !values?.possuiNotaFiscalTransmitida &&
            !values?.possuiCobrancaRegistrada && (
              <Grid container spacing={3} className="mb-16">
                <Grid item xs={12}>
                  <button className={styles.buttonAdicionarEmail} type="button" href="" onClick={addEmail}>
                    Adicionar e-mail
                  </button>
                </Grid>
              </Grid>
            )}
        </>
      )}
      {values?.pagamento?.tipoPagamento === 'A_VISTA' && (
        <Grid container spacing={3} className="mb-16">
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  id="faturarContratoVendaJuntos"
                  name="faturarContratoVendaJuntos"
                  value={values?.faturarContratoVendaJuntos}
                  checked={values?.faturarContratoVendaJuntos}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="small"
                  disabled={values?.disableFaturarVendaContratoJuntos}
                />
              }
              label="Faturar a venda junto com o contrato"
            />
            <Tooltip
              title="Ao selecionar esta opção, o faturamento do contrato recorrente e da venda pontual será realizado em uma única transação."
              placement="top"
            >
              <button type="button">
                <FaQuestionCircle size={15} />
              </button>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  id="unificarCobrancaContratoVenda"
                  name="unificarCobrancaContratoVenda"
                  value={values?.unificarCobrancaContratoVenda}
                  checked={values?.unificarCobrancaContratoVenda}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="small"
                  disabled={values?.disableUnificarCobrancaContratoVenda}
                />
              }
              label="Unificar cobrança da venda com o contrato"
            />
            <Tooltip
              title="Se ativado, o sistema emitirá um único boleto para a cobrança do contrato recorrente junto com vendas avulsas no mesmo mês."
              placement="top"
            >
              <button type="button">
                <FaQuestionCircle size={15} />
              </button>
            </Tooltip>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default VendaFormaPagamento;
